import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SPAs não resetam o scroll ao trocar de rota: quem está no fim de uma página
 * e navega abre a próxima já rolada. Este componente volta ao topo a cada
 * mudança de pathname (âncoras via hash continuam funcionando).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // deixa o navegador tratar âncoras (#secao)
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
